/* eslint-disable react/no-danger */
import {
  AssetAllocationsIcon,
  Box,
  ChartIcon,
  ConstituentScreeningIcon,
  DefiningUniverseIcon,
  GKTypography,
  Grid2,
  RebalanceIcon,
  ResearchIcon,
  Show,
} from "components";
import { isEmpty } from "lodash";
import { useAppSelector } from "store/store";

const MethodologiesTab = () => {
  const { selectedBasket: basketData } = useAppSelector(
    (state) => state?.equityBasket,
  );

  const allDataArray = [
    {
      name: "Defining the Universe",
      value: basketData.methodologyUniverse,
      icon: DefiningUniverseIcon,
    },
    {
      name: "Research",
      value: basketData.methodologyResearch,
      icon: ResearchIcon,
    },
    {
      name: "Constituent Screening",
      value: basketData.methodologyConstituentScreening,
      icon: ConstituentScreeningIcon,
    },
    {
      name: "Weightage",
      value: basketData.methodologyWeightage,
      icon: ChartIcon,
    },
    {
      name: "Rebalance",
      value: basketData.methodologyRebalance,
      icon: RebalanceIcon,
    },
    {
      name: "Asset Allocation",
      value: basketData.methodologyAllocation,
      icon: AssetAllocationsIcon,
    },
  ];

  const areValueEmpty =
    isEmpty(basketData.methodologyAllocation) &&
    isEmpty(basketData.methodologyRebalance) &&
    isEmpty(basketData.methodologyWeightage) &&
    isEmpty(basketData.methodologyConstituentScreening) &&
    isEmpty(basketData.methodologyResearch) &&
    isEmpty(basketData.methodologyUniverse);

  return (
    <Grid2 container spacing={2}>
      <Show.When isTrue={!areValueEmpty} showNodata>
        {allDataArray?.map(
          (dataItem) =>
            dataItem?.value && (
              <Grid2 size={10} overflow={"auto"}>
                <Box
                  gap={1}
                  alignItems={"center"}
                  display={"flex"}
                  p={0.5}
                  borderRadius={2}
                  bgcolor={`var(--primary-50)`}
                >
                  <dataItem.icon
                    width={20}
                    height={20}
                    color={"var(--primary-900)"}
                  />
                  <GKTypography
                    color={"var(--primary-900)"}
                    fontWeight={600}
                    fontSize={16}
                  >
                    {dataItem?.name}
                  </GKTypography>
                </Box>

                <div
                  className="ck"
                  style={{
                    color: "#222",
                    lineHeight: "26px",
                    fontSize: 14,
                    textAlign: "justify",
                  }}
                  dangerouslySetInnerHTML={{ __html: dataItem?.value || "-" }}
                />
              </Grid2>
            ),
        )}
      </Show.When>
    </Grid2>
  );
};

export default MethodologiesTab;
